import { render, staticRenderFns } from "./ArticleManagerLoader.vue?vue&type=template&id=5b99c816"
import script from "./ArticleManagerLoader.vue?vue&type=script&lang=ts"
export * from "./ArticleManagerLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports